var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex fCol acen"},[_c('div',[_vm._v("版权所有：深圳市福田区慈善会 备案序号：粤ICP备17019828号")]),_c('div',[_vm._v("地址：深圳市福田区新洲南路石厦四街233号福保街道办410")])])
}]

export { render, staticRenderFns }